import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

export function formatToRut(preRutString: string): string {
    if (!preRutString) return preRutString;
    preRutString = preRutString.toUpperCase().replace(/\./g, "").replace("-", "").trim();
    if (preRutString.length < 2) return preRutString;
    const numberRut = preRutString.slice(0, -1);
    const dv = preRutString.slice(-1);
    if (isNaN(+numberRut) && dv !== "K") {
        return preRutString;
    }
    return `${numberRut}-${dv}`;
}

@Directive({
    selector: "[appFormatRut]"
})
export class FormatRutDirective {
    constructor(private ngControl: NgControl) {}

    @HostListener("blur")
    onBlur() {
        const value: string = this.ngControl.control?.value;
        if (value) {
            const formatted = formatToRut(value);
            this.ngControl.control?.setValue(formatted, { emitEvent: false });
        }
    }
}